var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-profile"},[_c('keep-alive',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath,on:{"change":_vm.changeSelection}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }